import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Players.css";
import { useNavigate } from "react-router-dom";

const Players = () => {

  const navigate = useNavigate();

  const [players, setPlayers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [authorized,
  setAuthorized] =
  useState(false);

  useEffect(() => {

  verifyAdmin();

}, []);

  const loadPlayers = async () => {

    try {

      const res = await axios.get(
        "/api/admin/players"
      );

      setPlayers(res.data);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }

  };
 const verifyAdmin =
  async () => {

    if (
      localStorage.getItem(
        "adminAuth"
      ) === "true"
    ) {

      setAuthorized(true);
      loadPlayers();
      return;

    }

    const password =
      prompt(
        "Enter Admin Password"
      );

    if (!password) return;

    try {

      await axios.post(
        "/api/admin-login",
        { password }
      );

      localStorage.setItem(
        "adminAuth",
        "true"
      );

      setAuthorized(true);

      loadPlayers();

    } catch {

      alert(
        "Access Denied"
      );

    }

  };

  const searchPlayers = async (value) => {

    setSearch(value);

    try {

      if (!value.trim()) {
        loadPlayers();
        return;
      }

      const res = await axios.get(
        `/api/admin/player-search?q=${value}`
      );

      setPlayers(res.data);

    } catch (err) {

      console.error(err);

    }

  };

  if (loading) {
    return (
      <div className="players-page">
        <h2>Loading Players...</h2>
      </div>
    );
  }

  return (
    <div className="players-page">

      <h1 className="players-title">
        Players Management
      </h1>

      <input
        type="text"
        placeholder="Search Name or Email"
        value={search}
        onChange={(e) =>
          searchPlayers(e.target.value)
        }
        className="search-box"
      />

      <div className="table-container">

        <table className="players-table">

          <thead>

            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Allowed Tests</th>
              <th>Action</th>
            </tr>

          </thead>

          <tbody>

            {players.length === 0 ? (

              <tr>
                <td
                  colSpan="6"
                  style={{
                    textAlign: "center",
                    padding: "20px"
                  }}
                >
                  No Players Found
                </td>
              </tr>

            ) : (

              players.map((player) => (

                <tr key={player._id}>

                  <td>
                    {player.name || "-"}
                  </td>

                  <td>
                    {player.email}
                  </td>

                  <td>
                    {player.phone || "-"}
                  </td>

                  <td>

                    <span
                      className={
                        player.status === "active"
                          ? "status-active"
                          : "status-inactive"
                      }
                    >
                      {player.status}
                    </span>

                  </td>

                  <td>
                    {player.allowed_tests?.length || 0}
                  </td>

                  <td>

                   <button
                    className="view-btn"
                    onClick={() =>
                      navigate(
                        `/admin-playerhistory/${encodeURIComponent(player.email)}`
                      )
                    }
                  >
                    View
                  </button>
                     

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default Players;